import React from 'react';
import PropTypes from 'prop-types';
import clsNames from 'classnames';
import ShipsticksIcon from 'images/shipsticks-icon.png';

const RateCard = ({ rate, classNames, brand }) => {
  const formatPrice = (price) => `$${(price / 100).toFixed(2)}`;

  const { has_alternate_price: hasAlternatePrice } = rate;

  const cardClass = clsNames(
    classNames,
    `${rate.service_level.toLowerCase()}`,
    'bg-gray-100 border border-gray-300 rounded-lg shadow-sm min-w-[275px]',
    {
      'text-center': brand !== 'shipsticks',
      'rounded-t-lg': hasAlternatePrice,
    }
  );

  return (
    <div className={cardClass}>
      <div className="flex items-center px-8 py-4">
        <div className="flex-grow">
          <h2 className="text-2xl font-bold text-gray-900">{rate.service_type}</h2>

          {hasAlternatePrice ? (
            <div className="text-lg font-bold">
              <span className="line-through decoration-[#f94219] decoration-[3px] pr-2">{formatPrice(rate.price)}</span>
              <span className="text-[#f94219]">{formatPrice(rate.alternate_price)}</span>
            </div>
          ) : (
            <div className="text-lg font-bold text-gray-900">{formatPrice(rate.price)}</div>
          )}

          <div className="italic text-gray-600">{rate.display}</div>
        </div>
        {brand === 'shipsticks' && (
          <div className="
            flex-shrink-0 ml-4 flex items-center justify-center h-16 w-16 rounded-full bg-white border border-gray-200
          ">
            <img
              src={ShipsticksIcon}
              alt={rate.service_type} />
          </div>
        )}
      </div>

      {hasAlternatePrice ? (
        <div className="text-white text-center bg-[#4faf55] rounded-b-lg py-0.5">
          Limited Time Only!
        </div>
      ) : null}
    </div>
  );
};

RateCard.propTypes = {
  rate: PropTypes.shape({
    service_type: PropTypes.string.isRequired,
    service_level: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    alternate_price: PropTypes.number,
    display: PropTypes.string.isRequired,
    has_alternate_price: PropTypes.bool,
  }).isRequired,
  classNames: PropTypes.string,
  brand: PropTypes.string,
};

RateCard.defaultProps = {
  rate: {
    alternate_price: 0,
    has_alternate_price: false,
  }
};

export default RateCard;
